<template>
  <div class="home">
    <b-container>
      <b-button
        :to="'/home/' + this.$route.params.outlet"
        variant="outline-primary"
        class="cst-button--small"
      >
        <div
          class="cst-button__wrapper cst-button__icon cst-button__icon--left"
        >
          <img src="../assets/Left@2x.png" alt="" /> Kembali
        </div>
      </b-button>
      <div class="divider divider--margin-small"></div>

      <div class="divider divider--margin-small mobile-small-show"></div>
      <b-row>
        <b-col md="4" lg="8" xl="8">
          <div class="text-title">
            <h2>Penilaian</h2>
            <!-- <p>Terima kasih atas kunjungan Anda. Bagikan pengalaman Anda terhadap petugas kami.</p> -->
          </div>
        </b-col>
        <b-col
          md="8"
          lg="4"
          xl="4"
          class="btnprevnextslider"
          style="text-align: center"
        >
          <div class="btn cst-button--small btn-outline-primary prevSlider">
            <div
              class="
                cst-button__wrapper cst-button__icon cst-button__icon--left
              "
            >
              <img src="@/assets/Left@2x.png" alt="" />
            </div>
          </div>
          &nbsp;
          <div class="btn cst-button--small btn-outline-primary nextSlider">
            <div class="cst-button__wrapper cst-button__icon">
              <img src="@/assets/Right-dark@2x.png" alt="" />
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="divider divider--margin-small mobile-small-show"></div>
      <div class="divider mobile-small-hide"></div>
      <div class="cst-tabs">
        <swiper v-if="employees" :options="swiperOption" ref="semuaSwiper">
          <swiper-slide v-for="(employee, index) in employees" :key="index">
            <router-link
              :to="`/home/${$route.params.outlet}/${$route.params.id}/${
                employee.is_facility ? 'facilities' : 'employees'
              }/${employee.npp}`"
              class="profile-card profile-card--shadow"
            >
              <div class="profile-card__image profile-card__image--2">
                <div
                  class="inner"
                  :style="{
                    backgroundImage: 'url(\'' + employee.image + '\')',
                    backgroundPosition: 'center center',
                    backgroundSize: 'contain ',
                    backgroundRepeat: 'no-repeat',
                  }"
                >
                  <h3>{{ employee.position_name }}</h3>
                </div>
              </div>
              <div
                class="profile-card__content"
                style="min-height: 60px; margin-top: 0.5em"
              >
                <h1>{{ employee.name.toUpperCase() }}</h1>
                <!-- <h2>{{ employee.npp }}</h2> -->
              </div>
            </router-link>
          </swiper-slide>
          <div
            class="swiper-pagination mobile-small-show"
            slot="pagination"
          ></div>
        </swiper>
        <swiper v-else :options="swiperOption" ref="semuaSwiper">
          <swiper-slide>Tidak ada data petugas</swiper-slide>
        </swiper>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from "@/api/employees";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "penilaian",
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {
    this.getEmployees();
  },
  data() {
    return {
      hasResult: false,
      employees: null,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 10,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".nextSlider",
          prevEl: ".prevSlider",
        },
      },
    };
  },
  methods: {
    getEmployees() {
      var self = this;
      this.loadingText = "Loading...";
      api
        .get(this.$route.params.outlet, this.$route.params.id)
        .then(function (response) {
          // handle success
          if (response.data.data.length > 0) {
            self.hasResult = true;
            self.employees = response.data.data;
          } else {
            self.hasResult = false;
            self.employees = null;
          }
        })
        .catch(function (error) {
          console.log(error);
          self.loadingText = "Outlet tidak ditemukan";
          self.hasResult = false;
          self.employees = null;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>